import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { PermitsV2MetaDataItemNames, Permits2PermitEntity, PermitsV2MetaDataService, NoteTypeAllItems, PermitStatusAllItems, 
         CodeValueInspectionResults, CodeValueInspectionState, Permits2RoInspectionsEntity } 
         from '../meta-data/permitsv2-meta-data.service';
import { DwMetaDataRoutingService, DwActionResult, DwMenuActionType, DwAction, DwActionType, DwMdFormActionResult, DwMdFormActionHandler,
         DwMdFormActionState, DwQueryHelper, DwModalConfig, DwModalService, DwModalSize, DwOrmDataService, DwOrmDataServiceToken, 
         DwConfirmDialogConfig, DwSecurityUserService } 
         from '@devwareapps/devware-cap';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';

@DwAction({
  keyName: 'Permits_V2_Take_Ownership',
  display: 'Permits V2 - Take Ownership',
  actionType: DwActionType.formAction,
  isGlobal: false,
  parentItemName: [ PermitsV2MetaDataItemNames.Permits2Permit ],
  defaultButtonConfig: {
    buttonClass: 'btn-sm btn-warning mr-1 mt-1',
    iconClass: 'fa fa-th-list',
    buttonText: 'Take Ownership'
  },
})
@Injectable()
export class PermitV2TakeOwnershipActionService implements DwMdFormActionHandler {
  constructor(
    private metaDataRoutingService: DwMetaDataRoutingService,
    private dwModalService: DwModalService,
    protected securityService: DwSecurityUserService,
    @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService
  ) { }

  handleAction(formActionState: DwMdFormActionState): Observable<DwActionResult> {
    const permitEntity: Permits2PermitEntity = formActionState.formApi.getFormData()

        const confirmDialogConfig: DwConfirmDialogConfig = {
          message: "<div>This will reassign the permit request to <b>you</b>. <br/><br/><b><i>Note</i>:</b> Use 'Apply Changes' or 'Save' in order to save this change.</div>",
          title: 'Take Ownership?',
          showConfirmDialog: true,
        };
        return this.dwModalService.showConfirmDialog(confirmDialogConfig)
                   .pipe(map(result => 
                    {
                      if (result){
                        const wachterUser = new WachterUserExt(this.securityService.securityContext.ApplicationUser);
                        const CurrentUserTrustId = wachterUser.trustUserId;
                        formActionState.formApi.patchFormData({ AssignedToUserId: CurrentUserTrustId});
                      }
                      return { success: result };
                    }));
  }
}
